import { render, staticRenderFns } from "./AssignRequest.vue?vue&type=template&id=2cb5885c"
import script from "./AssignRequest.vue?vue&type=script&lang=ts"
export * from "./AssignRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports